'use client';

import { Image } from '@/components/atoms';
import { PlayAllButton, List } from '@/components/molecules';
import { useMediaController } from '@/lib/hooks/media-controller/useMediaController';
import { cn } from '@/lib/utils/tailwind';

import { ContentTypeVariations } from '../../CardCarousel';

import type {
  Album,
  NewsItem,
  Playlist,
  PersonalPlaylist,
  FavoritesForController,
  RecentsForController,
  PlaylistTrack,
} from '@/lib/api';

export const ItemPrefix = ({
  imageUrl,
  rawData,
  startIndex,
  mediaType,
  trackId,
  trackList,
}: {
  imageUrl: string;
  title: string;
  rawData:
    | Album
    | Playlist
    | NewsItem
    | PersonalPlaylist
    | FavoritesForController
    | RecentsForController
    | undefined;
  startIndex: number;
  mediaType: ContentTypeVariations;
  trackId?: number;
  trackList?: PlaylistTrack[];
}) => {
  const { trackIndex } = useMediaController();
  const isCurrentTrack = trackIndex === startIndex;

  return (
    <List.ItemPrefix
      as={'span'}
      className={cn('relative w-16 h-16 md:w-16 md:h-16')}
    >
      <div className="group relative w-16 h-16 md:w-16 md:h-16">
        <Image
          src={imageUrl}
          alt=""
          fill
          className="object-cover w-16 h-16 md:w-16 md:h-16"
        />
        <div
          className={cn(
            'absolute inset-0 transition-opacity duration-300 flex items-center justify-center',
            isCurrentTrack
              ? 'opacity-100'
              : 'opacity-0 group-hover:opacity-100 group-focus-within:opacity-100',
          )}
        >
          <PlayAllButton
            mediaType={mediaType}
            rawData={rawData}
            startIndex={startIndex}
            trackId={trackId}
            overriddenTrackList={trackList}
          />
        </div>
      </div>
    </List.ItemPrefix>
  );
};
